import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'niko-empty-state',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  template: `
    <div class="niko-empty-state" [class.niko-empty-state--warn]="forbidden() || !!error()">
      <p class="niko-empty-state__title">{{ resolvedTitle() | transloco }}</p>
      @if (resolvedHint()) {
        <p class="niko-empty-state__hint">{{ resolvedHint()! | transloco }}</p>
      }
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
      margin-top: 4px;
    }
    .niko-empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 2px;
      width: 100%;
      box-sizing: border-box;
      padding: 8px 12px;
      border-radius: var(--niko-radius-md, 8px);
      background: var(--niko-primary-fixed);
      color: var(--niko-on-primary-fixed);
    }
    .niko-empty-state--warn {
      background: var(--niko-error-container);
      color: var(--niko-on-error-container);
    }
    .niko-empty-state__title {
      margin: 0;
      font-family: 'Inter', sans-serif;
      font-size: 0.75rem;
      font-weight: 600;
      line-height: 1.3;
    }
    .niko-empty-state__hint {
      margin: 0;
      font-family: 'Inter', sans-serif;
      font-size: 0.6875rem;
      font-weight: 400;
      line-height: 1.3;
      opacity: 0.85;
    }
  `],
})
export class EmptyStateComponent {
  readonly title = input.required<string>();
  readonly hint = input<string | null>(null);
  readonly error = input<string | null>(null);

  readonly forbidden = computed(() => this.error() === 'errors.forbidden');

  readonly resolvedTitle = computed(() => {
    if (this.forbidden()) return 'errors.forbiddenTitle';
    if (this.error()) return 'common.error';
    return this.title();
  });

  readonly resolvedHint = computed(() => {
    if (this.forbidden()) return 'errors.forbiddenHint';
    if (this.error()) return this.error();
    return this.hint();
  });
}
